import { Component, Input, OnInit } from '@angular/core';
import { StoreService } from '../../services/store.service';
import { Play } from '../../models/play';
import { Map } from '../../models/map';
import { COLORS } from '../../constants/colors';

import * as _ from 'lodash';

@Component({
    selector: 'bt-play-thumb',
    templateUrl: './play-thumb.component.html',
    styleUrls: ['./play-thumb.component.scss'],
    standalone: false
})
export class PlayThumbComponent implements OnInit {
  @Input() play: Play;
  @Input() showActions = true;
  @Input() showActive = false;

  storeMap: Map;
  backgroundColor = '#303030';

  constructor(
    protected storeService: StoreService
  ) {
  }

  ngOnInit() {
    this.backgroundColor = this.getPlayColor(this.play);
    this.storeService.getMap(this.play.storeId).subscribe(map => {
      this.storeMap = map;
    });
  }

  getPlayTypeName() {
    return Play.getPlayTypeName(this.play.playType);
  }

  getPlayColor(play: Play) {
    let color = '#303030';

    if (!_.isNil(play)) {
      switch (play.playType) {
        case Play.TYPE_INSIGHT:
          color = COLORS.INSIGHT;
          break;
        case Play.TYPE_INSPECT:
          color = COLORS.INSPECT;
          break;
        case Play.TYPE_FOCUS:
          color = COLORS.FOCUS;
          break;
        case Play.TYPE_RFID:
          color = COLORS.RFID;
          break;
        case Play.TYPE_SECUIRTY_CHECKPOINT_WALK:
          color = COLORS.SECURITY_CHECKPOINT;
          break;
        case Play.TYPE_SECURITY_PATROL:
          color = COLORS.SECURITY_PATROL;
          break;
      }
    }

    return color;
  }
}
